import { array, boolean, mixed, number, object, string } from "yup";

import {
  PriorClaimInput,
  PriorClaimSource,
} from "@covertree/new-business-graphql";
import {
  nonEmptyString,
  nonFutureDateAndNotBeforeTwentyCentury,
} from "@covertree/utils";

export enum ClaimCategory {
  InteriorWater = "Interior Water",
  Other = "Other",
  CollisionVehicleAircraft = "Collision/Vehicle/Aircraft",
  Liability = "Liability",
  Earthquake = "Earthquake",
  FireSmoke = "Fire/Smoke",
  Flood = "Flood",
  WeatherHail = "Weather - Hail",
  WeatherLightning = "Weather - Lightning",
  WeatherWater = "Weather - Water",
  WeatherWind = "Weather - Wind",
  MedicalPayments = "Medical Payments",
  TheftBurglary = "Theft/Burglary",
  VandalismOrMaliciousMischief = "Vandalism or Malicious Mischief",
}

const maxClaimAmount = 999999999;

export interface PriorClaimsFormInput
  extends Omit<PriorClaimInput, "category" | "subjects" | "date"> {
  category: ClaimCategory;
  insured: string;
  date: string;
}

export interface PriorClaimsForm {
  claims: PriorClaimsFormInput[];
}

const priorClaimsValidation = object({
  insured: nonEmptyString("Insured"),
  category: mixed<ClaimCategory>()
    .oneOf(Object.values(ClaimCategory), "Category is required")
    .required("Category is required"),
  amount: number()
    .min(0, "Claim amount should not be lower than $0")
    .max(maxClaimAmount, "Claim amount should not be higher than $999,999,999")
    .typeError("Claim amount is required")
    .required("Claim amount is required"),
  date: nonFutureDateAndNotBeforeTwentyCentury("Date of loss"),
  catastrophe: boolean().notRequired(),
  source: mixed<PriorClaimSource>()
    .oneOf(Object.values(PriorClaimSource), "Source is required")
    .required("Source is required"),
  fieldGroupLocator: string().optional(),
});

export const priorClaimsFormValidation = object({
  claims: array().of(priorClaimsValidation),
});
